const getPatientList = state => state.patientList;
const getTotalPatient = state => state.totalPatient;
const getPatients = state => state.patients;

export default {
  getPatientList,
  getTotalPatient,
  getPatients,
};
